import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import React, { useLayoutEffect, useEffect, useRef } from 'react';
import { isPreRelease } from '@finect/front-utils/isPreRelease';
import { deepEqual } from '@finect/front-utils/deepEqual';
import { withTrackable } from '../withTrackable';
import { dataLayer } from '.';
function runAfterHeadSettled(cb) {
  var done = false;
  var finish = function finish() {
    if (done) return;
    done = true;
    try {
      cb();
    } catch (e) {}
    cleanup();
  };
  var cleanup = function cleanup() {};
  try {
    var head = typeof document !== 'undefined' ? document.head : null;
    if (!head) {
      return requestAnimationFrame(function () {
        return requestAnimationFrame(finish);
      });
    }
    var idleTimer = null;
    var schedule = function schedule() {
      if (idleTimer) clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        requestAnimationFrame(function () {
          return requestAnimationFrame(finish);
        });
      }, 0);
    };
    var mo = new MutationObserver(function () {
      return schedule();
    });
    mo.observe(head, {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true
    });
    cleanup = function cleanup() {
      try {
        mo.disconnect();
      } catch (e) {}
      if (idleTimer) clearTimeout(idleTimer);
    };
    schedule();
    setTimeout(finish, 500);
  } catch (e) {
    requestAnimationFrame(function () {
      return requestAnimationFrame(finish);
    });
  }
}
function ensureGlobalUrlListener() {
  if (typeof window === 'undefined') return;
  var w = window;
  if (w.__fi_datalayer_url_listener_installed) return;
  w.__fi_datalayer_url_listener_installed = true;
  var getUrlKey = function getUrlKey() {
    return "".concat(window.location.pathname).concat(window.location.search);
  };
  w.__fi_datalayer_last_url_key = getUrlKey();
  w.__fi_datalayer_last_pathname = window.location.pathname;
  w.__fi_datalayer_last_search = window.location.search;
  var fireSceneReadyOncePerUrl = function fireSceneReadyOncePerUrl() {
    var prevPath = w.__fi_datalayer_last_pathname;
    var prevSearch = w.__fi_datalayer_last_search;
    var currPath = window.location.pathname;
    var currSearch = window.location.search;
    var pathChanged = prevPath !== currPath;
    var searchChanged = prevSearch !== currSearch;
    w.__fi_datalayer_last_pathname = currPath;
    w.__fi_datalayer_last_search = currSearch;
    var currentKey = "".concat(currPath).concat(currSearch);
    var fromKey = "".concat(prevPath).concat(prevSearch);
    w.__fi_datalayer_last_url_key = currentKey;
    var shouldAutoFire = false;
    if (!pathChanged && searchChanged) {
      shouldAutoFire = true;
      isPreRelease && console.log('[Datalayer] URL changed (same path, different params): auto sceneReady scheduled', {
        from: fromKey,
        to: currentKey
      });
    } else if (pathChanged) {
      var prevSeg = prevPath.split('/').filter(Boolean);
      var currSeg = currPath.split('/').filter(Boolean);
      var sameDepth = prevSeg.length === currSeg.length;
      if (sameDepth) {
        shouldAutoFire = true;
        isPreRelease && console.log('[Datalayer] URL changed (same depth, different path params): auto sceneReady scheduled', {
          from: fromKey,
          to: currentKey
        });
      } else {
        isPreRelease && console.log('[Datalayer] URL path changed (different depth): skip auto sceneReady', {
          from: fromKey,
          to: currentKey
        });
      }
    } else {
      return;
    }
    if (!shouldAutoFire) return;
    w.__fi_datalayer_pending_global_key = currentKey;
    var maybeFire = function maybeFire() {
      if (w.__fi_datalayer_cancel_global_key === currentKey) {
        isPreRelease && console.log('[Datalayer] Global sceneReady CANCELLED due to scene "ready"', {
          for: currentKey
        });
        w.__fi_datalayer_cancel_global_key = null;
        w.__fi_datalayer_pending_global_key = null;
        return;
      }
      if (w.__fi_datalayer_pending_global_key !== currentKey) return;
      runAfterHeadSettled(function () {
        if (w.__fi_datalayer_cancel_global_key === currentKey) {
          isPreRelease && console.log('[Datalayer] Global sceneReady CANCELLED late due to scene "ready"', {
            for: currentKey
          });
          w.__fi_datalayer_cancel_global_key = null;
          w.__fi_datalayer_pending_global_key = null;
          return;
        }
        isPreRelease && console.log('[Datalayer] ······ sceneReady lanzado (auto param-like change)');
        dataLayer({
          id: 'Scene',
          type: 'sceneReady',
          params: {}
        });
        w.__fi_datalayer_pending_global_key = null;
      });
    };
    setTimeout(maybeFire, 0);
  };
  window.addEventListener('popstate', fireSceneReadyOncePerUrl);
  var originalPushState = history.pushState;
  var originalReplaceState = history.replaceState;
  history.pushState = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    originalPushState.apply(this, args);
    fireSceneReadyOncePerUrl();
  };
  history.replaceState = function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    originalReplaceState.apply(this, args);
    fireSceneReadyOncePerUrl();
  };
}
function DatalayerBeta(props) {
  var id = props.id,
    type = props.type,
    _props$params = props.params,
    params = _props$params === void 0 ? {} : _props$params,
    trackHistory = props.trackHistory,
    setTargetingParams = props.setTargetingParams;
  var prevParamsRef = useRef();
  var track = React.useCallback(function () {
    isPreRelease && console.log('[Datalayer] track called', {
      id: id,
      type: type,
      params: params
    });
    var layer = dataLayer({
      id: id,
      type: type,
      params: params
    });
    if (layer && layer.targeting) setTargetingParams(layer.targeting);
  }, [id, type, params, setTargetingParams]);
  var trackReadyScene = React.useCallback(function () {
    runAfterHeadSettled(function () {
      var key;
      try {
        key = "".concat(window.location.pathname).concat(window.location.search);
        var core = window.__finect_dataLayer;
        if (core && core.last_ready_key === key) {
          isPreRelease && console.log('[Datalayer] sceneReady SKIPPED (already emitted for this URL)', {
            for: key
          });
          try {
            if (window.__fi_datalayer_cancel_global_key === key) window.__fi_datalayer_cancel_global_key = null;
          } catch (e2) {}
          return;
        }
      } catch (e) {}
      try {
        window.__fi_datalayer_cancel_global_key = key;
      } catch (e3) {}
      isPreRelease && console.log('[Datalayer] ······ sceneReady lanzado');
      dataLayer({
        id: 'Scene',
        type: 'sceneReady',
        params: {}
      });
      try {
        if (window.__fi_datalayer_cancel_global_key === key) window.__fi_datalayer_cancel_global_key = null;
      } catch (e4) {}
    });
  }, []);
  useEffect(function () {
    ensureGlobalUrlListener();
  }, []);
  useLayoutEffect(function () {
    if (prevParamsRef.current === undefined) {
      if (id === 'FiEvent' && (params === null || params === void 0 ? void 0 : params.category) === 'Interaction') {
        isPreRelease && console.log('[Datalayer] Mount: skip FiEvent Interaction');
        prevParamsRef.current = params;
        return;
      }
      if (type === 'ready') {
        isPreRelease && console.log('[Datalayer] Mount: send sceneReady');
        try {
          var key = "".concat(window.location.pathname).concat(window.location.search);
          window.__fi_datalayer_cancel_global_key = key;
        } catch (e) {}
        trackReadyScene();
        prevParamsRef.current = params;
        return;
      }
      isPreRelease && console.log('[Datalayer] Mount: track');
      track();
      prevParamsRef.current = params;
      return;
    }
    if (!deepEqual(params, prevParamsRef.current)) {
      if (type === 'ready') {
        isPreRelease && console.log('[Datalayer] Update: send sceneReady');
        try {
          var _key3 = "".concat(window.location.pathname).concat(window.location.search);
          window.__fi_datalayer_cancel_global_key = _key3;
        } catch (e) {}
        trackReadyScene();
        prevParamsRef.current = params;
        return;
      }
      isPreRelease && console.log('[Datalayer] Update: track');
      track();
      prevParamsRef.current = params;
    }
  }, [id, type, params, track, trackReadyScene]);
  return null;
}
export default withTrackable(DatalayerBeta);